<template>
	<button
		v-if="props.podcast"
		@click="store.toggleFavorite(props.podcast.id)"
		class="text-sm font-bold rounded-full w-9 h-9 cursor-pointer border hover:bg-red hover:border-red flex justify-center items-center"
		:class="{ '!bg-red !border-red': store.isFavorite(props.podcast.id) }"
	>
		<svg width="16" height="14" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.98828 0.5C8.7116 0.500107 9.19476 0.98887 9.40137 1.70703C9.61532 2.45093 9.4698 3.25545 9.09961 3.66504C7.95496 4.93152 6.83427 6.18227 6 7.11621C5.58292 7.58312 5.23747 7.97105 4.99609 8.24219C4.99507 8.24334 4.99321 8.24397 4.99219 8.24512L4.99121 8.24414C4.75197 7.97286 4.40937 7.5843 3.99512 7.11719C3.16659 6.18295 2.05141 4.93208 0.90625 3.66504C0.534414 3.25363 0.38607 2.44731 0.594727 1.7041C0.796179 0.986838 1.27329 0.5 1.99512 0.5C2.83372 0.500102 3.46267 0.909322 3.90039 1.35156C4.11843 1.57186 4.28138 1.79365 4.38965 1.95996C4.44351 2.04271 4.48357 2.11074 4.50879 2.15625C4.52136 2.17895 4.52979 2.19661 4.53516 2.20703C4.53771 2.21199 4.54014 2.21503 4.54102 2.2168L4.99121 3.15234L5.44043 2.21875L5.44141 2.21777L5.44043 2.2168H5.44141C5.44231 2.21498 5.44474 2.21193 5.44727 2.20703C5.45264 2.19661 5.46104 2.17897 5.47363 2.15625C5.49886 2.11073 5.53892 2.04267 5.59277 1.95996C5.70109 1.79366 5.86397 1.57182 6.08203 1.35156C6.51996 0.909234 7.1495 0.5 7.98828 0.5Z" stroke="currentColor"/>
		</svg>

	</button>
</template>

<script setup>
import { defineProps } from 'vue'
import { usePodcastStore } from '../stores/podcastStore'

const store = usePodcastStore()

const props = defineProps({
	podcast: {
		type: Object,
		required: true
	}
})

</script>
